module.exports = "/_next/static/images/235f42184ba7713c9e15991168c7522c-wow@1x.png";